import script from "./rightCard1.vue?vue&type=script&setup=true&lang=js"
export * from "./rightCard1.vue?vue&type=script&setup=true&lang=js"

import "./rightCard1.vue?vue&type=style&index=0&id=4893b847&scoped=true&lang=scss"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4893b847"]])

export default __exports__